import * as Sentry from '@sentry/vue';
// @ts-ignore
import vSelect from 'vue-select';
import PortalVue from 'portal-vue';
//@ts-ignore
import {i18n} from './i18n-setup';
import ErrorApi from "./api/ErrorApi";
import UserAuthApi from "./api/UserAuthApi";
import LogService from "./services/LogService";
import ConferenceManager from "./video/ConferenceManager";
import AnalyticsApi from "./api/AnalyticsApi";

require('./bootstrap');
require('./directives');

const store = require('./store');

let Vue = require('vue').default;
//@ts-ignore
window.Vue = Vue;

Vue.config.devtools = (process.env.NODE_ENV !== 'production');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// @ts-ignore
const files = require.context('./components', true, /\.vue$/i);
// @ts-ignore
files.keys().map(key => Vue.component(key.split('/').pop()?.split('.')[0], files(key).default));

Vue.use(PortalVue);

Vue.component('v-select', vSelect);

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: process.env.MIX_VUE_APP_SENTRY_DSN,
        attachProps: true,
        logErrors: true,
    });
}

declare module 'vue/types/vue' {
    interface Vue {
        $errorApi: ErrorApi,
        $userAuthApi: UserAuthApi,
        $logService: LogService,
        $conferenceManager: ConferenceManager,
        $analyticsApi: AnalyticsApi,
    }
}

const logService = new LogService();
const conferenceManager = new ConferenceManager();

Vue.prototype.$errorApi = new ErrorApi();
Vue.prototype.$analyticsApi = new AnalyticsApi();
Vue.prototype.$userAuthApi = new UserAuthApi();
Vue.prototype.$logService = logService;
Vue.prototype.$conferenceManager = conferenceManager;

new Vue({
    store,
    i18n,
}).$mount('#app');
